import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const STORAGE_KEY = "rg_admin_token";

export const adminApi = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
    const token = window.localStorage.getItem(STORAGE_KEY);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

adminApi.interceptors.response.use(
    (r) => r,
    (error) => {
        const status = error?.response?.status;
        if (status === 401) {
            window.localStorage.removeItem(STORAGE_KEY);
            // Avoid redirect loops if already on login
            if (typeof window !== "undefined" && !/\/admin\/login/.test(window.location.pathname)) {
                window.location.replace("/admin/login");
            }
        }
        return Promise.reject(error);
    },
);

export const adminAuth = {
    storageKey: STORAGE_KEY,
    getToken: () => window.localStorage.getItem(STORAGE_KEY),
    setToken: (t) => window.localStorage.setItem(STORAGE_KEY, t),
    clearToken: () => window.localStorage.removeItem(STORAGE_KEY),
    async login(username, password) {
        const { data } = await adminApi.post("/admin/login", { username, password });
        window.localStorage.setItem(STORAGE_KEY, data.token);
        return data;
    },
    async me() {
        const { data } = await adminApi.get("/admin/me");
        return data;
    },
    async logout() {
        try {
            await adminApi.post("/admin/logout");
        } catch (_e) {
            // ignore — token might already be invalid
        }
        window.localStorage.removeItem(STORAGE_KEY);
    },
};

export const downloadLeadsCsv = async () => {
    const token = adminAuth.getToken();
    const url = `${API}/admin/leads/export.csv`;
    const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error(`Failed: ${res.status}`);
    const blob = await res.blob();
    const a = document.createElement("a");
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = `raj-graphics-leads-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
};
